import { render, staticRenderFns } from "./OpportunitiesInfluencersTable.vue?vue&type=template&id=cb84807a&scoped=true&"
import script from "./OpportunitiesInfluencersTable.vue?vue&type=script&lang=js&"
export * from "./OpportunitiesInfluencersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb84807a",
  null
  
)

export default component.exports